export const FREQ_OPTIONS = [
  { value: 0, text: 'None' },
  { value: 24, text: '24h' },
  { value: 12, text: '12h' },
  { value: 6, text: '6h' },
  { value: 3, text: '3h' },
  { value: 1, text: '1h' },
]

export const IP_FRQ_LEVELS = [
  { value: 'l1', text: 'Level 1' },
  { value: 'l2', text: 'Level 2' },
  { value: 'l3', text: 'Level 3' },
  { value: 'l4', text: 'Level 4' },
  { value: 'l5', text: 'Level 5' },
]

export function connType(v) {
  const s = String(v || 'all').toLowerCase()
  if (s === 'wifi') return 'wifi'
  if (s === '3g' || s === 'cellular') return '3G'
  return 'all'
}

export function geoCode(v) {
  return String(v || '').replace(/^!/, '').split(',')[0].trim().toUpperCase()
}

export function regionGeoOk(geo) {
  const c = geoCode(geo)
  return c === 'US' || c === 'CA'
}

export function osFlags(os) {
  const s = String(os || '').toLowerCase()
  if (!s || s === 'all') return { ios: true, android: true }
  return {
    ios: s.indexOf('ios') !== -1,
    android: s.indexOf('android') !== -1
  }
}

export function osFromFlags(ios, android) {
  if (ios && android) return ''
  if (ios) return 'iOS'
  if (android) return 'Android'
  return ''
}

export function connFlags(v) {
  const s = connType(v)
  if (s === 'all') return { wifi: true, cell: true }
  return { wifi: s === 'wifi', cell: s === '3G' }
}

export function connFromFlags(wifi, cell) {
  if (wifi && cell) return 'all'
  if (wifi) return 'wifi'
  return '3G'
}

export function osSum(os) {
  const f = osFlags(os)
  if (f.ios && f.android) return 'iOS+Android'
  if (f.ios) return 'iOS'
  if (f.android) return 'Android'
  return '—'
}

export function connSum(v) {
  const f = connFlags(v)
  if (f.wifi && f.cell) return 'wifi+3G'
  if (f.wifi) return 'wifi'
  if (f.cell) return '3G'
  return '—'
}

export function trafficSum(row) {
  const parts = []
  if (row && row.traffic_in_app) parts.push('In-App')
  if (row && row.traffic_mobile) parts.push('MW')
  return parts.length ? parts.join('+') : '—'
}

export function creativeSum(row) {
  const parts = []
  if (row && row.creative_tag) parts.push('TAG')
  if (row && row.creative_img) parts.push('IMG')
  return parts.length ? parts.join('+') : '—'
}

export const SUB_OPTIONS = ['Sub1', 'Sub2', 'Sub3', 'Sub4', 'Sub6', 'Sub7', 'Sub8']

export const SUB_VALUES_LIMIT = 65000

export const CAMPAIGN_LINK_TEMPLATE = 'https://go.accesspointz.com/redirectV2?camp_id={camp_id}'

export function freqLbl(v) {
  const o = FREQ_OPTIONS.find(x => Number(x.value) === Number(v))
  return o ? o.text : 'None'
}

export function ipLevelLbl(v) {
  const o = IP_FRQ_LEVELS.find(x => x.value === v)
  return o ? o.text : 'Level 3'
}

export function campaignLink(campId) {
  return CAMPAIGN_LINK_TEMPLATE.replace('{camp_id}', campId)
}

export function normVals(raw) {
  return String(raw || '').split(/[\s,;]+/).map(s => s.replace(/\s+/g, '')).filter(Boolean)
}

export function normStr(raw) {
  return normVals(raw).join(',')
}

export function valCount(raw) {
  return normVals(raw).length
}

export function ruleValCount(r) {
  const extras = (r && r.extras) || []
  return valCount(r && r.values) + extras.reduce((n, e) => n + valCount(e), 0)
}

export function trimSubRules(rules) {
  ;(rules || []).forEach(r => {
    r.values = normStr(r.values)
    r.extras = (r.extras || []).map(normStr).filter(Boolean)
  })
  return rules
}

export function payloadSubRules(rules) {
  return (rules || []).map(r => ({
    sub: r.sub,
    mode: r.mode,
    raw_values: normStr(r.values),
    extras: (r.extras || []).map(normStr).filter(Boolean)
  }))
}

export function lostClass(pct) {
  if (pct >= 80) return 'hi'
  if (pct >= 40) return 'mid'
  return 'ok'
}

export function fmtNum(v) {
  const n = Number(isNaN(v) ? 0 : v)
  if (!n) return '0'
  return n.toLocaleString()
}

export function fmtPct(v) {
  const n = Number(v || 0)
  return n.toFixed(0) + '%'
}

export function subChips(rules) {
  const bl = []
  const wl = []
  ;(rules || []).forEach(r => {
    const num = String(r.sub || '').replace(/Sub/i, 'S')
    if (r.mode === 'whitelist') wl.push(num)
    else bl.push(num)
  })
  return { bl, wl }
}

export const PAUSE_UNITS = ['Minutes', 'Hours', 'Days']

export function pauseToMinutes(val, unit) {
  const n = Math.max(0, parseInt(val, 10) || 0)
  if (unit === 'Minutes') return n
  if (unit === 'Days') return n * 60 * 24
  return n * 60
}

export function minutesToPause(m) {
  const n = Number(m) || 0
  if (n > 0 && n % (60 * 24) === 0) return { pauseVal: n / (60 * 24), pauseUnit: 'Days' }
  if (n > 0 && n % 60 === 0) return { pauseVal: n / 60, pauseUnit: 'Hours' }
  if (n > 0) return { pauseVal: n, pauseUnit: 'Minutes' }
  return { pauseVal: 1, pauseUnit: 'Hours' }
}

export const LOSS_GROUPS = [
  {
    label: 'Frequency',
    keys: [
      { key: 'idfa_frq_reached_error', label: 'IDFA_FRQ_REACHED_ERROR' },
      { key: 'ip_frq_reached_error', label: 'IP_FRQ_REACHED_ERROR' },
      { key: 'delivery_frq_error', label: 'DELIVERY_FRQ_ERROR' }
    ]
  },
  {
    label: 'Blacklisting',
    keys: [
      { key: 'hardcode_subs_block', label: 'HARDCODE_SUBS_BLOCK' },
      { key: 'sl_sub_n', label: 'SL_SUB_N' },
      { key: 'offer_sub_5', label: 'OFFER_SUB_5' },
      { key: 'offer_sub_n', label: 'OFFER_SUB_N' },
      { key: 'bl_blocked', label: 'BL_BLOCKED' },
      { key: 'isp_blocked', label: 'ISP_BLOCKED' }
    ]
  },
  {
    label: 'Targeting',
    keys: [
      { key: 'camp_not_exist', label: 'CAMP_NOT_EXIST' },
      { key: 'camp_group_pause', label: 'CAMP_GROUP_PAUSE' },
      { key: 'camp_pause', label: 'CAMP_PAUSE' },
      { key: 'adset_os', label: 'ADSET_OS' },
      { key: 'adset_clickcap', label: 'ADSET_CLICKCAP' },
      { key: 'adset_geo', label: 'ADSET_GEO' },
      { key: 'adset_region', label: 'ADSET_REGION' },
      { key: 'adset_connection_type_error', label: 'ADSET_CONNECTION_TYPE_ERROR' },
      { key: 'traffic_type_11', label: 'TRAFFIC_TYPE_11' },
      { key: 'creative_type_12', label: 'CREATIVE_TYPE_12' },
      { key: 'affise_offer_pause', label: 'AFFISE_OFFER_PAUSE' },
      { key: 'offer_clickcap', label: 'OFFER_CLICKCAP' },
      { key: 'global_offer_daily_click_cap', label: 'GLOBAL_OFFER_DAILY_CLICK_CAP' },
      { key: 'global_offer_weekly_click_cap', label: 'GLOBAL_OFFER_WEEKLY_CLICK_CAP' },
      { key: 'global_offer_monthly_click_cap', label: 'GLOBAL_OFFER_MONTHLY_CLICK_CAP' },
      { key: 'connection_type_error', label: 'CONNECTION_TYPE_ERROR' },
      { key: 'idfa_only_block', label: 'IDFA_ONLY_BLOCK' },
      { key: 'os_version_blocked', label: 'OS_VERSION_BLOCKED' },
      { key: 'no_offer_available', label: 'NO_OFFER_AVAILABLE' }
    ]
  }
]

export const LOSS_CAT_COLS = [
  { key: 'lost_frequency', label: 'Frequency' },
  { key: 'lost_blacklisting', label: 'Blacklisting' },
  { key: 'lost_targeting', label: 'Targeting' }
]

export function visibleLossGroups(stats) {
  const s = stats || {}
  return LOSS_GROUPS.map(g => ({
    label: g.label,
    keys: g.keys.filter(k => Number(s[k.key]) > 0)
  })).filter(g => g.keys.length > 0)
}

export function placeLossPop(anchorEl, popEl) {
  if (!anchorEl || !popEl) return {}
  const r = anchorEl.getBoundingClientRect()
  const popW = popEl.offsetWidth || 300
  const popH = popEl.offsetHeight || 0
  const gap = 6
  const pad = 12
  let left = r.right - popW
  if (left < pad) left = pad
  if (left + popW > window.innerWidth - pad) left = Math.max(pad, window.innerWidth - popW - pad)
  let top = r.bottom + gap
  if (popH && top + popH > window.innerHeight - pad) {
    const above = r.top - popH - gap
    top = above >= pad ? above : Math.max(pad, window.innerHeight - popH - pad)
  }
  return {
    position: 'fixed',
    top: Math.round(top) + 'px',
    left: Math.round(left) + 'px',
    zIndex: 10050,
    visibility: 'visible'
  }
}

export function pauseReleaseLeft(offer, nowMs) {
  if (!offer || !offer.paused) return ''
  const start = Date.parse(offer.pause_ts || '')
  if (!start) return ''
  const end = start + (Number(offer.pause_duration_minutes) || 0) * 60000
  let sec = Math.floor((end - nowMs) / 1000)
  if (sec < 0) sec = 0
  const h = Math.floor(sec / 3600)
  const m = Math.floor((sec % 3600) / 60)
  const s = sec % 60
  const pad = n => (n < 10 ? '0' : '') + n
  return h + ':' + pad(m) + ':' + pad(s)
}
